import { Stack } from '@fluentui/react';
import clsx from 'clsx';
import { RemoveRowButton } from 'common/components/Buttons';
import {
  FormHookDropdown,
  FormHookTextField,
} from 'common/components/FormHooksFields';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { DietaryRequirementsOptionsProps } from '..';
import { TravelerValues } from '../../../types';
import { useStyles } from './index.styles';
interface DietaryRequirementsInputRowProps {
  fieldName: string;
  dietaryRequirementsOptions: DietaryRequirementsOptionsProps[];
  onChange: () => void;
  onRemove: () => void;
  isFirstRow: boolean;
  rowIndex: number;
  inputsDisabled: boolean;
}

export const DietaryRequirementsInputRow: React.FC<
  DietaryRequirementsInputRowProps
> = ({
  fieldName,
  dietaryRequirementsOptions,
  onChange,
  onRemove,
  isFirstRow,
  rowIndex,
  inputsDisabled,
}) => {
  const styles = useStyles();
  const { watch, setValue } = useFormContext<TravelerValues>();

  const row = watch('travelerDietaryRequirementsByTravelerId')?.[rowIndex];
  const showDeleteButton = !!row?.dietaryRequirementId;
  const showDescription = !!row?.isDescriptionRequired;

  const onDietaryRequirementsChange = (
    selectedOption: DietaryRequirementsOptionsProps
  ) => {
    onChange();
    setValue(
      `${fieldName}.isDescriptionRequired` as any,
      !!selectedOption.isDescriptionRequired,
      { shouldDirty: true }
    );
    setValue(`${fieldName}.description` as any, null, { shouldDirty: true });
  };

  return (
    <Stack
      horizontal
      tokens={{
        childrenGap: 20,
        padding: '10px 0px',
      }}
    >
      <Stack.Item className={styles.inputsContainer}>
        {
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 10 }}>
          {!inputsDisabled && (
            <Stack.Item
              className={clsx(!isFirstRow && styles.removeButtonContainer)}
            >
              {showDeleteButton && <RemoveRowButton onClick={onRemove} />}
            </Stack.Item>
          )}
          <FormHookDropdown
            placeholder="Select Dietary Requirements"
            options={dietaryRequirementsOptions || []}
            name={`${fieldName}.dietaryRequirementId`}
            onChange={(_e, option) => {
              onDietaryRequirementsChange(
                option as DietaryRequirementsOptionsProps
              );
            }}
            onClear={onRemove}
            styles={{
              dropdown: {
                width: 547,
              },
            }}
            disabled={inputsDisabled}
          />
        </Stack>
        }
      </Stack.Item>
      <Stack.Item className={styles.inputsContainer}>
        {showDescription && (
          <FormHookTextField
            placeholder="Description"
            name={`${fieldName}.description`}
            disabled={inputsDisabled}
          />
        )}
      </Stack.Item>
    </Stack>
  );
};
